class KsysEventBus extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }
}
export function defineEventBusComponent() {
    if (customElements.get('ksys-event-bus') === undefined) {
        customElements.define('ksys-event-bus', KsysEventBus);
    }
}



// WEBPACK FOOTER //
// ./src/ksys-event-bus.ts